export function createBillingCompanyColumns() {
  const columns = [
    {
      id: 'id',
      Header: 'Ordre',
      accessor: 'id',
      minWidth: 60,
      maxWidth: 60,
      filterable: false,
    },
    {
      Header: 'Sender Ref',
      id: 'orderReference',
      accessor: 'orderReference',
      minWidth: 100,
      maxWidth: 120,
      filterable: false,
    },
    {
      Header: 'Date created',
      id: 'createdDate',
      accessor: 'createdDate',
      maxWidth: 100,
      filterable: false,
    },
    {
      Header: 'Date delivered',
      id: 'deliverFrom',
      accessor: 'deliverFrom',
      maxWidth: 150,
      filterable: false,
    },
    {
      Header: 'Sender Name',
      id: 'senderName',
      accessor: 'senderName',
      minWidth: 40,
      maxWidth: 100,
      filterable: false,
    },
    {
      Header: 'Mottaker',
      id: 'recipientName',
      accessor: 'recipientName',
      minWidth: 80,
      maxWidth: 120,
      filterable: false,
    },
    {
      Header: 'Recipient Address',
      id: 'recipientAddress',
      accessor: 'recipientAddress',
      minWidth: 80,
      maxWidth: 260,
      filterable: false,
    },
    {
      Header: 'Price',
      id: 'price.fractionalDenomination',
      accessor: 'price.fractionalDenomination',
      minWidth: 80,
      maxWidth: 260,
      filterable: false,
    },
  ];
  return columns;
}
